import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ElectricChargerOffFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.3241 5.75778L22.0455 3.03646L20.7727 1.76367L15.2592 7.27712C14.8277 7.3359 14.4946 7.54472 14.2599 7.88003V4.08003H3.8999V18.6364L1.69751 20.8388L2.9703 22.1116L5.24188 19.84H5.25304L14.2599 10.8332V10.822L15.7399 9.34201V9.35318L16.9554 8.13767C16.9541 8.13526 16.9528 8.13285 16.9515 8.13045L18.25 6.83192C18.2514 6.8342 18.2529 6.83648 18.2543 6.83877L19.3291 5.76397C19.3275 5.76191 19.3258 5.75984 19.3241 5.75778ZM11.3763 11.16L7.61703 14.9193L8.7199 12.64H6.0999L9.5399 8.68003H10.6399L9.4399 11.16H11.3763ZM18.6599 8.97876L20.0752 7.56348C20.0915 7.71044 20.0999 7.86252 20.0999 8.02003V16.82C20.0999 17.94 19.2199 19 17.9199 19C16.6199 19 15.7399 17.94 15.7399 16.82V11.8988L17.1799 10.4588V16.82C17.1799 17.22 17.5199 17.56 17.9199 17.56C18.3199 17.56 18.6599 17.22 18.6599 16.82V8.97876ZM14.2599 13.3788L7.79863 19.84H14.2599V13.3788Z"
      />
    </SvgIcon>
  );
});
